/**
 * Forma kimliği. **Kaynak Unity forma kitaplığıdır** (`BodyLibrarySetup.cs` +
 * `Assets/Takım Vucutlar`); kontrat şeması (`character-package.schema.json` → `outfitId` enum)
 * o listeyi taşır, backend doğrulaması da üretilmiş enum'dan okur (#27). Kiosk kontrattaki
 * listeyi sunar — sahnede giydirilemeyen NEUTRAL artık yok.
 *
 * **Etiketler kulüp adı değildir, olamaz (#116).** Kulüp adları da lakapları da (Kanarya, Aslan,
 * Kartal…) tescilli marka; misafire gösterilen bir yüzeyde etiket olarak kullanılamaz. Etiket
 * bu yüzden **tarifsel**: formanın renklerini söyler, takımı ima etmez. Tanıtma işini yazı
 * değil, kartta çizilen **gerçek forma sanatı** yapar (`src/assets/bodies/*.png`) — misafir
 * sarı-lacivert çubuklu formayı okumadan tanır. Buraya kulüp adı ya da lakabı geri konmaz.
 */

import type { CharacterPackage } from '../../contracts/generated/ts/character-package'

/** Kontrattan gelen tek doğru liste — kiosk kendi kopyasını tutmaz (ADR-004). */
export type OutfitId = CharacterPackage['outfitId']

interface OutfitStyle {
  id: OutfitId
  /** Formanın renklerini tarif eden etiket. Kulüp adı/lakabı **değil** (#116). */
  label: string
  /** Forma ana rengi — kartların ışıması ve isim rengi bundan türer. */
  color: string
  accent: string
}

/** Kontrat dışı kalmış eski kayıtlar için düşülecek görünüm — seçilemez. */
const LEGACY = {
  id: null,
  label: 'FORMA YOK',
  color: '#8B5CFF',
  accent: '#F044C7',
}

/** Misafire gösterilen seçenekler — sıra ekranda göründüğü sıradır. */
export const SELECTABLE_OUTFITS: OutfitStyle[] = [
  { id: 'FB', label: 'SARI LACİVERT', color: '#FFED00', accent: '#1B458F' },
  { id: 'GS', label: 'SARI KIRMIZI', color: '#FDB913', accent: '#A90432' },
  { id: 'BJK', label: 'SİYAH BEYAZ', color: '#EDEDED', accent: '#111111' },
  { id: 'TS', label: 'BORDO MAVİ', color: '#C8102E', accent: '#00539F' },
  { id: 'MILLI', label: 'KIRMIZI BEYAZ', color: '#E30A17', accent: '#FFFFFF' },
  // Aşağıdakiler takım forması DEĞİL -- özgün karakter kostümleri (Osmanlı/astronot/aşçı/
  // dansçı/pembe). #116'nın yasakladığı şey kulüp formasını lakabıyla anmak; bunlar kulüp
  // forması olmadığı için tematik isimler kullanılıyor (ürün sahibi kararı, 2026-09-10).
  { id: 'PF', label: 'PEMBE FIRTINA', color: '#FF1B8D', accent: '#FFFFFF' },
  { id: 'OSM', label: 'SARAY ASLANI', color: '#C1121F', accent: '#FFD700' },
  { id: 'UZAY', label: 'UZAY FORVETI', color: '#FF6B1A', accent: '#FFFFFF' },
  { id: 'SEF', label: 'GOL ŞEFİ', color: '#E63946', accent: '#111111' },
  { id: 'DISKO', label: 'DISKO YILDIZI', color: '#9B30D9', accent: '#3EE0D6' },
]

export function outfitStyle(outfitId: string | null): OutfitStyle | typeof LEGACY {
  return SELECTABLE_OUTFITS.find((o) => o.id === outfitId) ?? LEGACY
}
